import { NavLink } from 'react-router-dom';
import { LayoutDashboard, History, TrendingUp, Disc, Settings } from 'lucide-react';

const NAV_ITEMS = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    to: '/dashboard',
    icon: <LayoutDashboard className="w-5 h-5" />
  },
  {
    id: 'history',
    label: 'History',
    to: '/history',
    icon: <History className="w-5 h-5" />
  },
  {
    id: 'futures',
    label: 'Trade',
    to: '/futures/up-down',
    icon: <TrendingUp className="w-5 h-5" />
  },
  {
    id: 'spin-wheel',
    label: 'Jackpot',
    to: '/spin-wheel',
    icon: <Disc className="w-5 h-5" />
  },
  {
    id: 'settings',
    label: 'Settings',
    to: '/settings',
    icon: <Settings className="w-5 h-5" />
  }
];

export function MobileBottomNav({ activePage, onNavigate }) {
  const renderItem = (item) => {
    // Determine active state by matching the current URL path or activePage prop
    const isActive = activePage === item.id;

    return (
      <NavLink
        key={item.id}
        to={item.to}
        onClick={onNavigate}
        className={`mobile-bottom-nav__item ${isActive ? 'is-active' : ''}`}
        aria-current={isActive ? 'page' : undefined}
      >
        <span className="mobile-bottom-nav__icon">{item.icon}</span>
        <span className="mobile-bottom-nav__label">{item.label}</span>
      </NavLink>
    );
  };

  return (
    <nav className="mobile-bottom-nav" aria-label="Mobile navigation">
      {NAV_ITEMS.map((item) => renderItem(item))}
    </nav>
  );
}
